import React from 'react';
import { StyledTextArea } from './TextArea.styles';
import { ComponentSize } from '../types';
import { Status, Variant } from './types';

export type TextAreaProps = {
  size?: ComponentSize;
  status?: Status;
  fullWidth?: boolean;
  variant?: Variant;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextArea = ({
  size = 'medium',
  status,
  fullWidth = true,
  variant = 'primary',
  ...rest
}: TextAreaProps) => {
  return (
    <StyledTextArea
      size={size}
      fullWidth={fullWidth}
      status={status}
      variant={variant}
      {...rest}
    />
  );
};

export default TextArea;
